// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"7":"a508c6b6","23":"cfe67d1e","87":"cc1639ed","121":"f83eb7cc","163":"65aa1d53","251":"1a4ffae7","256":"25a4a499","460":"e92cc32f","616":"80da314b","693":"3971a5cc","767":"d9224403"}[chunkId] + ".chunk.js";
};